module.exports = __webpack_public_path__ + "static/media/arrow-left.ffc0c137.svg";